import newCashExpense from "./newCashExpense";

export default newCashExpense;
